__turbopack_context__.v({
  "errorPageBody": "ErrorPage-module-scss-module__z8M7PW__errorPageBody",
  "errorPageContent": "ErrorPage-module-scss-module__z8M7PW__errorPageContent",
  "errorPageDescription": "ErrorPage-module-scss-module__z8M7PW__errorPageDescription",
  "errorPageImage": "ErrorPage-module-scss-module__z8M7PW__errorPageImage",
  "errorPageTitle": "ErrorPage-module-scss-module__z8M7PW__errorPageTitle",
});
